import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";
import { disabledStyle } from "../../../Common/ClickDisable";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import { useDispatch, useSelector } from "react-redux";
import { addOTS, updateOTS } from "../../../../redux/ots/action";
import {
  removepresent,
} from "../../../Common/FewCommonMethods";
import { descriptionvalidation, pricevalidation, titlevalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import { isDurationLessThanMilestones } from "../../../../utils/isDurationLessThanMilestones";
import { isPriceWithinBudget } from "../../../../utils/isPriceWithinBudget";
import MilestonesFieldArray from "./MilestonesFieldArray";
import { getPostCounts } from "../../../../redux/posts/action";

const bxpDatatomap = [
  { title: "Price in $", name: "price", placeholder: "Enter total cost" },
  {
    title: (<>Payment terms <AsteriskLabel /></>),
    name: "payment_type",
    placeholder: "Payment terms",
  },
  { title: "Milestones", name: "milestones", placeholder: "Milestones" },
  {
    title: "Additional Notes / Terms",
    name: "terms",
    placeholder: "Type here",
  },
];
const milestonedata = {
  title: "",
  duration: "",
  amount: "",
  penalty: "",
  duration_type: "",
  status: 1,
};

const PricingTerms = ({ updateindex, bxpData, setActiveTab, setModalOpen, setModal }) => {
  const [penaltyInputMode, setPenaltyInputMode] = useState({});
  const [loading, setLoading] = useState(null);
  const dispatch = useDispatch();
  const penaltylist = useSelector(
    ({ categary: { penaltylist } }) => penaltylist
  );
  const penaltylisting = penaltylist || [];

  const initialValues = {
    price: bxpData?.price || "",
    payment_type: bxpData?.payment_type || 2,
    terms: bxpData?.terms || "",
    milestones: bxpData?.milestones || [milestonedata],
  };


  const validationSchema = Yup.object().shape({
    price: pricevalidation,
    terms: descriptionvalidation,
    payment_type: Yup.string().required("Payment terms are required"),

    milestones: Yup.mixed().when("payment_type", {
      is: "2",
      then: () =>
        Yup.array()
          .min(1, "At least one milestone is required")
          .of(
            Yup.object().shape({
              title: titlevalidation,
              duration: Yup.number()
                .required("This Field is Required")
                .test("not-zero", "Duration should not be 0", (value) => value > 0)
                .typeError("Duration must be a number"),
              duration_type: Yup.string()
                .required("Duration Type is Required")
                .test(
                  "not-only-spaces",
                  "Duration Type is Required",
                  (value) => value && value.trim() !== ""
                ),
              amount: Yup.number()
                .required("This Field is Required")
                .test("not-zero", "Amount should not be 0", (value) => value > 0)
                .typeError("Amount must be a number"),
              penalty: Yup.string()
                .required("This Field is Required")
                .test(
                  "not-only-spaces",
                  "This Field is Required",
                  (value) => value && value.trim() !== ""
                ),
            })
          ),
      otherwise: () => Yup.array().notRequired(),
    }),
  });



  const handleSubmit = async (values, formikHelpers) => {
    const isDurationValid = isDurationLessThanMilestones(
      bxpData.duration,
      bxpData.duration_type,
      values.milestones
    );

    const isBudgetValid = isPriceWithinBudget(values.price, values.milestones);

    if (!isDurationValid || !isBudgetValid) {
      formikHelpers.setErrors({
        duration: !isDurationValid
          ? "Total milestone duration cannot exceed total project duration."
          : undefined,
        price: !isBudgetValid
          ? "Total milestone amounts cannot exceed project budget."
          : undefined,
      });
      return;
    }
    setLoading(true);
    try {
      const updatedBxpData = {
        ...bxpData,
        price: values.price,
        payment_type: values.payment_type,
        terms: values.terms,
        milestones: values.milestones,
      };
      console.log(updatedBxpData, 'THIS IS PAYLOAD');

      if (updateindex != null) {
        dispatch(updateOTS(updatedBxpData, setLoading));
      } else {
        dispatch(addOTS(updatedBxpData, setLoading));
        localStorage.removeItem("OTS_ADD_DRAFT");
      }

      setModalOpen(false);
      setModal(false);
    } catch (error) {
      console.error("Error submitting BXP:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const handleProficiencyChange = (selectedOption, index, setFieldValue) => {
    setFieldValue(`milestones[${index}].penalty_id`, selectedOption.value);
    setFieldValue(`milestones[${index}].penalty`, removepresent(selectedOption.label));
  };

  const handlePenaltyInputChange = (event, index, setFieldValue) => {
    setFieldValue(
      `milestones[${index}].penalty`,
      removepresent(event.target.value)
    );
    setFieldValue(`milestones[${index}].penalty_id`, 0);
  };

  const handleDeadlinetypeChange = (selectedOption, index, setFieldValue) => {
    setFieldValue(`milestones[${index}].duration_type`, selectedOption.value);
  };

  const togglePenaltyMode = (index) => {
    setPenaltyInputMode((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div>
      <Formik
        key={updateindex ?? bxpData?.id ?? "pricing-terms"} // keep key stable
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => {
          console.log("Values:", formik.values);
          console.log("Errors:", formik.errors);
          console.log("Touched:", formik.touched);

          return (
            <>
              <ErrorMessage
                name={'duration'}
                component="div"
                className="error"
              />
              <Form>
                {formik.errors?.duration && (
                  <>
                    {(() => {
                      const durationLabel =
                        bxpData?.duration_type == 1
                          ? "Hour"
                          : bxpData?.duration_type == 2
                            ? "Days"
                            : bxpData?.duration_type == 3
                              ? "Week"
                              : "Month";

                      return (
                        <>
                          <p>
                            Project Duration : {bxpData?.duration} {durationLabel}
                          </p>
                          <p style={{ color: "red" }}>{formik.errors?.duration}</p>
                          <br></br>
                        </>
                      );
                    })()}
                  </>
                )}

                <div>
                  {bxpDatatomap.map((prop, key) => {
                    if (prop.name == "payment_type") {
                      return (
                        <div key={key} className="form-group">
                          <h6 className="work-title">{prop.title}</h6>
                          <div className="label-check">
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                name={prop.name}
                                value="1"
                                checked={formik.values.payment_type == "1"}
                                onChange={() =>
                                  formik.setFieldValue("payment_type", "1")
                                }
                              />
                              <span className="checkmark">
                                One time <span>(Full Payment)</span>
                              </span>
                            </label>
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                name={prop.name}
                                value="2"
                                checked={formik.values.payment_type == "2"}
                                onChange={() => {
                                  formik.setFieldValue("payment_type", "2")
                                  formik.setFieldValue("milestones", [milestonedata])
                                }
                                }
                              />
                              <span className="checkmark">By Milestones</span>
                            </label>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        </div>
                      );
                    }
                    if (prop.name == "milestones") {
                      if (
                        prop.name == "milestones" &&
                        formik.values.payment_type == "2"
                      ) {
                        return (
                          <MilestonesFieldArray
                            formik={formik}
                            penaltyInputMode={penaltyInputMode}
                            togglePenaltyMode={togglePenaltyMode}
                            handleProficiencyChange={handleProficiencyChange}
                            handlePenaltyInputChange={handlePenaltyInputChange}
                            handleDeadlinetypeChange={handleDeadlinetypeChange}
                            penaltylisting={penaltylisting}
                          />
                        );
                      }
                      return null;
                    }
                    if (prop.name == "price") {
                      return (
                        <NumberInputBox
                          type={"number"}
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    }
                    if (prop.name == "terms") {
                      return (
                        <>
                          <CustomReactQuill
                            value={formik.values[prop.name]}
                            formik={formik}
                            name={prop.name}
                            title={prop.title}
                          />
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                            style={{ color: "red" }}
                          />
                        </>
                      );
                    }
                    return (
                      <FieldInput
                        title={prop.title}
                        name={prop.name}
                        placeholder={prop.placeholder}
                        key={key}
                      />
                    );
                  })}
                  <div className="button-container">
                    <p
                      style={loading ? disabledStyle : {}}
                      className="prev-button w-100"
                      onClick={() => setActiveTab("WorkSamples")}
                    >
                      Back
                    </p>
                    <button className="next-button w-100" type="submit">
                      {loading ? (
                        <LoginLoaderButton />
                      ) : updateindex != null ? (
                        "Save and Publish"
                      ) : (
                        "Save and Publish"
                      )}
                    </button>
                  </div>
                </div>
              </Form>
            </>
          )
        }}
      </Formik>
    </div>
  );
};

export default PricingTerms;
